import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Progress } from 'uikit/progress';
import { Typo } from 'uikit/content';
import Card from './card';
import CardMedia from './cardMedia';
import CardMeta from './cardMeta';
import CardPill from './cardPill';

import styles from '../styles/uikitCardsCardDetailed.module.scss';

const CardDetailed = ({
  className = '',
  image = null,
  isExternalLink = false,
  isInProgress = false,
  layout = 'vertical',
  meta = '',
  metaIcon = '',
  progress = 0,
  status = '',
  subject = '',
  testId = '',
  title = '',
  to = '',
}) => (
  <Card
    className={classnames(styles.element, className)}
    testId={testId}
    to={to}
    isExternalLink={isExternalLink}
  >
    <div
      className={classnames(styles.content, {
        [styles.isHorizontal]: layout === 'horizontal',
      })}
    >
      <CardMedia className={styles.media} image={image} title={title}>
        {status && (
          <div className={styles.status}>
            <CardPill text={status} />
          </div>
        )}
        {isInProgress && (
          <div className={styles.progress}>
            <Progress size="small" value={progress} />
          </div>
        )}
      </CardMedia>
      <div className={styles.inner}>
        {subject && (
          <Typo
            className={styles.subject}
            element="span"
            variant="s01"
            modifier="uppercase"
          >
            {subject}
          </Typo>
        )}
        <Typo
          className={styles.title}
          element="h3"
          variant="d01"
          weight="bold"
        >
          {title}
        </Typo>
        {meta && <CardMeta icon={metaIcon} text={meta} />}
      </div>
    </div>
  </Card>
);

CardDetailed.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string,
  layout: PropTypes.oneOf(['vertical', 'horizontal']),
  meta: PropTypes.string,
  metaIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  progress: PropTypes.number,
  subject: PropTypes.string,
  status: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
  to: PropTypes.string,
  isExternalLink: PropTypes.bool,
  isInProgress: PropTypes.bool,
};

export default { ...React.memo(CardDetailed), displayName: 'CardDetailed' };
